module.exports = __webpack_public_path__ + "img/item4-1.d7355506.jpg";